// extracted by mini-css-extract-plugin
export default {"articleParagraph":"movies_articleParagraph__3M1b4"};